import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";


class UserAddressServices {
    private serviceName = '/master';

    async GetAllDofyGeo(serviceTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetAllDofyGeo?serviceTypeId=${serviceTypeId}`).catch((err: Error) => {
            throw err?.message;
        })
    }
}

export default new UserAddressServices();